import { useSettingQuery } from '@/features/auth/hooks/queries/useSettingQuery'
import type { ReleaseChannel } from '@/features/auth/types/setting'

// channel の順序 (= 大きいほど多くの機能が見える). alpha ⊇ beta ⊇ ga.
const CHANNEL_RANK: Record<ReleaseChannel, number> = {
  ga: 0,
  beta: 1,
  alpha: 2,
}

interface UseReleaseChannelReturn {
  channel: ReleaseChannel
  // β 顧客以上 (= β 機能への導線を出す). alpha も含む.
  isBeta: boolean
  // 社内検証者 (= α 機能への導線を出す).
  isAlpha: boolean
}

/**
 * ログインユーザーの release_channel を読み、α/β 機能の導線表示を分岐するための派生値を返す。
 * - server (custom_setting.release_channel) が source of truth。
 * - 未取得 / back 未デプロイ時は ga (= 全部非表示) へ倒す。
 * - isBeta / isAlpha は monotonic (alpha ⇒ beta) なので設定漏れの footgun が無い。
 */
export const useReleaseChannel = (): UseReleaseChannelReturn => {
  const { data: setting } = useSettingQuery()
  const channel: ReleaseChannel = setting?.release_channel ?? 'ga'
  const rank = CHANNEL_RANK[channel]
  return {
    channel,
    isBeta: rank >= CHANNEL_RANK.beta,
    isAlpha: rank >= CHANNEL_RANK.alpha,
  }
}
